import { mapState } from 'vuex';
import editPersonInfoModal from './editPersonInfoModal.vue';
import editPasswordModal from './editPasswordModal.vue';
import editPhoneModal from './editPhoneModal.vue';
export default {
  components: {
    editPersonInfoModal,
    editPasswordModal,
    editPhoneModal
  },
  data() {
    return {
      form: {
        globalRoaming: '',
        mobile: ''
      },
      visiblePersonInfo: false,
      // 个人信息弹框
      visiblePassword: false,
      // 修改密码弹框
      visiblePhone: false // 修改手机号弹框
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    encryMobile: {
      // 第四位到第七位替换成*
      get() {
        var _this$accountInfo;
        return (_this$accountInfo = this.accountInfo) === null || _this$accountInfo === void 0 || (_this$accountInfo = _this$accountInfo.mobile) === null || _this$accountInfo === void 0 ? void 0 : _this$accountInfo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
      },
      set(val) {
        console.log(val, '--------val----------');
      }
    }
  },
  async mounted() {
    // 更新store个人信息
    await this.$store.dispatch('user/getInfo');
  },
  methods: {
    handleCli(type) {
      switch (type) {
        case '1':
          this.visiblePersonInfo = true;
          break;
        case '2':
          this.visiblePassword = true;
          break;
        case '3':
          this.visiblePhone = true;
          break;
        default:
          break;
      }
    }
  }
};